<!--
 * @Author: Merlin
 * @Date: 2025-05-26 10:04:53
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-04 14:23:16
 * @Description: 
-->
<template>
	<NuxtLayout name="casino">
		<div class='coinflip-game'>
			<div class="coinflip-game-container">
				<div class="coinflip-game-content">
					<div class="coinflip-game-main">
						<div class="coinflip-game-section">
							<!-- 顶部操作菜单 start -->
							<ClientOnly>
								<GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
									<GameSettingsButtonLiveChat v-if="userStore?.isLoggedIn" v-model="isOpenLiveChat" />
									<GameSettingsButtonFast v-model="gameStore.coinflip.fast" />
									<GameSettingsButtonFairness v-model="isOpenFairness" />
									<GameSettingsButtonRule v-model="isOpenRule" name="coinflip" />
									<GameSettingsButtonVocie 
										v-model="settingStore.inhouseGames.sound.on" 
										v-model:voice-model-value="settingStore.inhouseGames.sound.music" 
										:saveAfterChange="true"
									/>
								</GameSettingsDiceTabsWrapper>
							</ClientOnly>
							<!-- 顶部操作菜单 end -->
							<!-- 游戏区域 start -->
							<div class="coinflip-game-row">
								<!-- 展示区 -->
								<ClientOnly>
									<div class="full-width h-fit bg-blue-grey-10 flex flex-col rounded-[10px] overflow-hidden">
										<!-- 历史记录 start -->
										<div class="coinflip-game-row-head bg-[#283343]">
											<ResultHistory :betHistory="betHistory" />
										</div>
										<!-- 历史记录 end -->
										<!-- 动画区域 start -->
										<BetBoard 
											:roundData="roundData"
											:showMultiAnimation="showMultiAnimation"
											:animationClass="animationClass"
											:resultCss="resultCss"
										/>
										<!-- 动画区域 end -->
									</div>
								</ClientOnly>
								<!-- 投注选项区域 start -->
								<ClientOnly>
									<BetOptions 
										v-model:bet-amount-modal-value="oForm.amount" 
										v-model:is-submiting="oForm.isSubmiting"
										:bet-submit="betSubmit"
										:is-fast="gameStore?.coinflip.fast"
										:toggleValue="roundData.toggleValue"
										:handleInstant="handleInstant"
										:roundData="roundData"
										:betTookit="betTookit && betTookit" 
										:cashoutAmount="cashoutAmount"
										:headTailAmount="headTailAmount"
										:betting="betting"
										:handleToggle="handleToggle"
									></BetOptions>
								</ClientOnly>
								<!-- 投注选项区域 end -->
								<BetResult 
									:result="betData" 
									:showResult="showResult" 
									v-if="showResult"
								/>
							</div>
							<!-- 游戏区域 end -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</NuxtLayout>
	
</template>
<script lang="ts">
import { defineComponent } from 'vue'
// stores
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useCoinFlipStore } from '@/stores/cansino/coinflip';
import type { ICoinFlip } from '@/socket/game/dto/index.dto';
// components
import BetOptions from './_components/betOptions/index.vue';
import ResultHistory from './_components/resultHistory/index.vue';
import BetResult from './_components/betResult/index.vue';
import BetBoard from './_components/betBoard/index.vue';
// function
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { winAmount, setAmountZero } from '@/pages/casino/plinkoGame/utils';
import { accMultiple } from "@/pages/casino/plinkoGame/js/module.js";
// socket
import { useGameSocket } from '@/socket/game';
// mp3
import lose from '@/assets/mp3/coinflip/losing.mp3'
import win from '@/assets/mp3/coinflip/win.mp3';
import placeBet from '@/assets/mp3/coinflip/place-bet.mp3';
import coin from '@/assets/mp3/coinflip/coinflip-coin.mp3';
import coinflipBGM from '@/assets/mp3/game_general_bgm.mp3';
import gsap from 'gsap';

export default defineComponent({
	name: 'coinflipGame',
	components: {
		BetOptions,
		ResultHistory,
		BetResult,
		BetBoard
	},
	data() {
		return {
			isRotate: null, // true--win false--lose null--default
			isOpenLiveChat: false, // 右侧统计
            isOpenFairness: false, // 公平性弹框
            isOpenRule: false, // 规则弹框
			gameStore: useSettingsStore().game,
            settingStore: useSettingsStore(),
			userStore: useUserStore(),
			joinStore: useJoinStateStore(),
			coinFlipStore: useCoinFlipStore(),
			oForm: {
                amount: 0,
                isSubmiting: false,
            },
			result: null, // 下注结果
			randomSeed: null, // 1-正面 0-反面
			roundData: {
				odds: 1, // 倍率（默认为1，只在此值为1时覆盖此值） 
				toggleValue: 'instant',// false-Instant true-Multiply
				toggleText: ['instant', 'multiply'],
				series: '-',
			},
			betParams: {
				// amount: undefined,
				frontID: new Date().getTime(),
				isFast: useSettingsStore().game.coinflip.fast,
				// prediction: undefined, // 押注、返现-undefined 押头-1 押尾-0
				// type
				// Instant 0-押头、押尾
				// Multiply 0-押注 1-押头、押尾 2-返现
				type: null
			},
			betData: {}, // 下注结果
			submitType: null, // 下注类型
			musicControler: null,
			soundOption: { // 音效配置
				bg: {
					src: coinflipBGM,
					loop: true,
					isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
				},
                coinflipLost: {
                    src: lose,
                },
                coinflipWin: {
                    src: win
                },
                coinflipBet: {
                    src: placeBet
                },
                coinflipCoin: {
                    src: coin
                }
            },
			betTookit: null,
			cashoutAmount: null, // 返现金额
			headTailAmount: null, // 下注预计收益
			betHistory: [], // 下注历史
			showResult: false, // 下注结果
			betting: false, // 是否正在调用下注接口 true--正在下注并禁用按钮
			fastDelay: 300,
			normalDelay: 1100,
			gsapModule: null, // 在 mounted 时被赋值 
		};
	},
	computed: {
		/**
		 * 根据rtp计算赢分倍数
		 */
		initMulti(){
			const rtp = this.joinStore.config.rtp;
			const calRtp = Number(Number.parseFloat(rtp) / 0.5) / 100;
			return calRtp;
		},
		// 硬币显示正面或背面
		animationClass(){
			// 1-正面 0-反面
			if (!!Number(this.randomSeed)){
				return 'coin-result-front'
			}
			return 'coin-result-back'
		},
		// Instant模式下注结果-文字
		resultCss(){
			if (this.gameStore.coinflip.fast){
				if (this.isRotate === true){
					return {
						class: 'result-win-fast',
						text: 'win'
					}
				}
				if (this.isRotate === false){
					return {
						class: 'result-lose-fast',
						text: 'lose'
					}
				}
				return {
					class: '',
					text: ''
				}
			} else {
				if (this.isRotate === true){
					return {
						class: 'result-win',
						text: 'win'
					}
				}
				if (this.isRotate === false){
					return {
						class: 'result-lose',
						text: 'lose'
					}
				}
				return {
					class: '',
					text: ''
				}
			}
		},
		// Multiply模式下动画效果
		showMultiAnimation(){
			if (this.roundData.toggleValue !== 'multiply'){
				return ''
			}
			if (this.isRotate === true){
				return 'multi-animation'
			}
			if (this.isRotate === false){
				return 'multi-animation multi-animation-lose'
			}
			return ''
		},
	},
	watch: {
		// 监听音效开关 是否播放背景音乐
        'settingStore.inhouseGames.sound.on': {
            handler(newVal){
                if (newVal && !this.musicControler){
                    // 音效初始化
					this.musicControler = new MusicControler(this.soundOption);
                }
            },
            immediate: true,
        },
		// 是否有 已下注但是未完成 的游戏记录
		'joinStore.lastRound': {
			handler(newVal, oldVal){
				if (newVal && Object.keys(newVal).length && JSON.stringify(newVal) !== JSON.stringify(oldVal)){
					this.coinFlipStore.accData = newVal;
					this.coinFlipStore.betOrBack = 'bet';

					this.roundData = {
						...this.roundData,
						odds: newVal?.multi === 1 ? 0 : newVal?.multi, 
						toggleValue: 'multiply',
						series: newVal?.state?.length
					}
					this.formatHeadTailAmount(newVal)
					this.betHistory = newVal.state;
					this.oForm.isSubmiting = true;
					showLastRoundLoadedInfo();
				} else if ((newVal && !Object.keys(newVal).length) || !newVal) {
					this.coinFlipStore.accData = {};
					this.coinFlipStore.betOrBack = '';
					this.roundData = {
						odds: this.initMulti, 
						toggleValue: 'instant',
						toggleText: ['instant', 'multiply'],
						series: '-'
					}
					this.formatHeadTailAmount({})
					this.betHistory = [];
					this.oForm.isSubmiting = false;
				}
			},
			deep: true,
			immediate: true,
		},
		'oForm.amount': {
			handler(newVal){
				if (!newVal) return;
				this.formatHeadTailAmount(this.coinFlipStore.accData)
			},
			immediate: true
		},
		'initMulti': {
			handler(fNewVal){
				// 只去覆盖默认值 1，防止覆盖残局的值 
				if (fNewVal > 0 && this.roundData.odds == 1){
					this.roundData.odds = fNewVal;
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.betTookit = useBettingToolkit(this.oForm)
		onUnmounted(() => {
			this.musicControler?.toDestory();
		});
		const gsapPromise = Promise.resolve({ gsap });
		this.gsapModule = markRaw(gsapPromise);
	},
	methods: {
		/**
		 * 添加金币翻转动画
		 */
		async handleAddAnimation(){
			const _this = this;
			const betData: any = this.betData;
			const dom = '#coin';
			// const t01 = Date.now();
			const oSleep = Sleep(this.gameStore.coinflip.fast ? this.fastDelay : this.normalDelay);
			const {gsap} = await this.gsapModule || {};
			if (!gsap){
				console.error('gsap CDN 加载失败'); 
				await oSleep;
				return;
			}
			const oResolvers = Promise.withResolvers();
			// console.log('await gsap 耗时 =', Date.now() - t01); // ≈1ms 
			const timeline = gsap.timeline({
				// 动画执行完毕后触发
				onComplete: async function(){
					if (!!_this.result){
						_this.isRotate = true;
						if (_this.settingStore.inhouseGames.sound.on){
							_this.musicControler?.oAudio.coinflipWin.toPlay();
						}
					} else {
						_this.isRotate = false;
						if (_this.settingStore.inhouseGames.sound.on){
							_this.musicControler?.oAudio.coinflipLost.toPlay();
						}
					}
					_this.oForm.isSubmiting = false;
					await oSleep;
					await Sleep(200);
					_this.isRotate = null;
					oResolvers.resolve(1);
				}
			});
			if (this.settingStore.inhouseGames.sound.on){
				this.musicControler?.oAudio.coinflipCoin.toPlay();
			}
			if (this.gameStore.coinflip.fast){ // 快速模式--只翻转，没有放大缩小效果
				timeline.fromTo(dom, 0.3, 
					{
                        rotationX: 0
                    },
                    {
                        rotationX: 360
                    })
			} else {
				timeline.fromTo(
					dom, 
					0.4,
					{
						rotationX: -720,
					},
					{
						rotationX: -190,
						z: 120,
					}
				).to(dom, {
						duration: 0.1,
						rotationX: -170,
					}).to(dom, {
						duration: 0.4,
						rotationX: 0,
						z: -15,
					}).to(dom, {
						duration: 0.1,
						z: 0,
					})
			}
			_this.result = betData.winAmount;
			_this.randomSeed = betData?.randomSeed?.slice(0, 1);
			this.joinStore.gameRunning = false;
			return oResolvers.promise;
		},
		/**
		 * 格式化beat-profit、cashout展示金额
		 */
		async formatHeadTailAmount(accData){
			const { toggleValue } = this.roundData;
			// Multiply模式
			if (toggleValue === 'multiply'){
				if (this.submitType !== 'back' && accData?.multi > 1){ // 下注赢分
					// 等待动画执行完毕
					(this.submitType === 'tail' || this.submitType === 'head') && await Sleep(this.gameStore.coinflip.fast ? this.fastDelay : this.fastDelay);
					// 下次赢分倍数
					const multi = accMultiple(accData?.multi, this.initMulti).toFixed(4);
					// 下次赢分
					const amount = winAmount(this.oForm.amount, multi);
					// 为下次赢分补0
					const zero = setAmountZero(this.oForm.amount, multi);
					// 累计赢分待返现
					const winAmounts = Number(accData.winAmount).toFixed(4);
					this.headTailAmount = `${amount}${zero}`;
					this.cashoutAmount = getFixed(Number(winAmounts));
				} else if (accData?.multi === 1){ // 点击bet按钮后
					this.cashoutAmount = '0.00';
					this.headTailAmount = `${winAmount(this.oForm.amount, this.initMulti)}${setAmountZero(this.oForm.amount, this.initMulti)}`;
				} else if (this.submitType === 'back' || accData.winAmount === 0){ // 点击cashout按钮后或者下注输分
					// 输分后等待动画执行完毕
					accData.winAmount === 0 && await Sleep(this.gameStore.coinflip.fast ? this.fastDelay : this.normalDelay);
					this.cashoutAmount = '';
					this.headTailAmount = '0.00'
				} else {
					this.cashoutAmount = '';
					this.headTailAmount = '0.00'
				}
			// Instant模式
			} else {
				this.headTailAmount = `${winAmount(this.oForm.amount, this.initMulti)}${setAmountZero(this.oForm.amount, this.initMulti)}`;
				this.cashoutAmount = '';
			}
		},
		/**
		 * 下注
		 */
		async betSubmit() {
			this.joinStore.gameRunning = true;
			this.betting = true;
			let ts;
			let oAnimationPromise = null;
			const isMultiply = this.roundData.toggleValue === 'multiply';
			const isBetting = this.submitType === 'bet';
			const iDealy = (
				(isMultiply && isBetting) 
				? 0 // 多轮模式的开局没有动画，不必延时 
				: (this.gameStore.coinflip.fast ? this.fastDelay : this.normalDelay)
			);
			const {oPromise, resolve} = createPromise();
			Promise.allSettled([
				oPromise,
				Sleep(iDealy),
			]).finally(()=>{
				// console.log('解锁按钮 🚺');
				this.betting = false;
			});
			const { EMIT_COINTFLIP_BET } = useGameSocket();
			try{
				// Instant模式专用，因为多轮模式下无论用户选择正反面金额都不会变化 
				if (!isMultiply){
					ts = this.userStore.queueStart(); // 防止余额立即变化
				}
				// 说明：多轮模式没有金额延时，因为开局时立即扣款 
				// 而且选择正反面后无论结果输赢都没有金额动画 
				// if (import.meta.env.DEV_MODE && 'Math.random() < 0.3'){
				// 	this.oForm.amount *= 1;
				// 	this.oForm.amount += 0.01;
				// 	this.betParams['amount'] = getFixed(this.oForm.amount, 2);
				// }
				EMIT_COINTFLIP_BET(this.betParams, async (res: any) => {
					if (res && !res.code){
						this.betData = res;
						this.formatHeadTailAmount(res)
						// 动画相关
						// 点击下注或返现，不播放动画
						if (!isBetting && this.submitType !== 'back'){
							oAnimationPromise = this.handleAddAnimation();
						}
						// multiply模式下
						// 点击bet、head、tail时存储下注结果
						if (isMultiply){
							if (this.submitType !== 'back' && res.winAmount){ // 开局操作，或中途押注 
								this.coinFlipStore.accData = res;
								// bet
								if (res?.multi === 1){
									this.betHistory = [];
									this.showResult = false;
								}
								if (!isBetting){
									await oAnimationPromise;
								}
								this.roundData = {
									...this.roundData,
									odds: res?.multi === 1 ? 0 : res?.multi,
									series: res.state.length
								}
								// head、tail
								if (res?.multi > 1){
									this.betHistory = res.state.reverse();
								}
							} else if (this.submitType === 'back'){ // 点击返现,清空下注结果
								this.coinFlipStore.accData = {};
								this.coinFlipStore.betOrBack = '';
								setTimeout(() => {
									this.joinStore.showDateInQueue();
								}, this.fastDelay)
								this.showResult = true;
								await Sleep(2_000);
								this.showResult = false;
								this.joinStore.gameRunning = false;
							
							} else if (res.winAmount === 0){ // 游戏结果为lose,清空下注结果
								// 添加延时，等动画执行完后再重置数据
								await oAnimationPromise;
								this.coinFlipStore.accData = {};
								this.coinFlipStore.betOrBack = '';
								this.roundData = {
									...this.roundData,
									odds: 0, 
									series: res.state.length
								}
								this.joinStore.showDateInQueue();
								this.betHistory = res.state.reverse();
								this.joinStore.gameRunning = false;
							}
						// Instant模式
						} else {
							// 添加延时，等动画执行完后再重置数据
							await oAnimationPromise;
							this.joinStore.showDateInQueue(); // 插入游戏结果并播放动画
							this.userStore.queueForward(ts); // 显示余额变化
							this.betHistory.unshift(res.state[0]);
						}
					} else {
						if (!isMultiply){
							this.userStore.queueDelete(ts);
						}
						showNegativeNotify(res?.error); 
						this.oForm.isSubmiting = false;
						this.joinStore.gameRunning = false;
						if (isMultiply){
							this.coinFlipStore.betOrBack = 'back';
							this.oForm.isSubmiting = false;
						}
					}
					resolve();
				});
			}catch(error){
				if (!isMultiply){
					this.userStore.queueDelete(ts);
				}
				console.log(error, 'coinflip-error');
				this.joinStore.gameRunning = false;
				resolve();
			}
		},
		/**
		 * toggle切换（本地无调用，以发子组件调用）  
		 * @param value true-Multiply false-Instant
		 */
		handleToggle(value){
			console.log(value, 'handleToggle--')
			this.betData = {};
			this.showResult = false;
			this.submitType = null;
			this.betHistory = [];
			console.log('this.coinFlipStore.accData', this.coinFlipStore.accData)
			this.formatHeadTailAmount(this.coinFlipStore.accData);
			if (value === 'multiply'){
				this.oForm.amount = this.coinFlipStore.accData.amount || this.oForm.amount;
				this.roundData = {
					// odds: this.coinFlipStore.accData?.multi === 1 ? 0 : this.coinFlipStore.accData?.multi || 0, 
					odds: 0, // 同原版，默认是0，开局后也是0，押输后也是0，仅赢之后值上涨 
					toggleValue: value,
					toggleText: ['instant', 'multiply'],
					series: this.coinFlipStore.accData?.state?.length || '0'
				}
			} else {
				this.roundData = {
					odds: this.initMulti, 
					toggleValue: value,
					toggleText: ['instant', 'multiply'],
					series: '-'
				}
			}
		},
		/**
		 * 不同模式下 下注（下发给子组件调用）
		 * @param e MouseEvent
		 * @param type head-押头 tail-押尾
		 */
		handleInstant(e: MouseEvent, type: string){
			const isStop = (
				this.betting
				|| (
					this.roundData.toggleValue === 'multiply'
					&& this.coinFlipStore.betOrBack !== 'bet'
				)
			);
			if (['head', 'tail'].includes(type) && isStop){
				return;
			}
			this.submitType = type;
			this.formatHeadTailAmount(this.coinFlipStore.accData)
			if (this.settingStore.inhouseGames.sound.on && (type === 'bet' || type === 'back')){
				this.musicControler?.oAudio.coinflipBet.toPlay();
			}
			// Multiply
			if (this.roundData.toggleValue === 'multiply'){
				switch(type){
					case 'head':
						this.betParams = {
							frontID: new Date().getTime(),
							isFast: useSettingsStore().game.coinflip.fast,
							type: 1,
							prediction: 1,
						} as ICoinFlip
						this.oForm.isSubmiting = true;
						break;
					case 'tail':
						this.betParams = {
							frontID: new Date().getTime(),
							isFast: useSettingsStore().game.coinflip.fast,
							type: 1,
							prediction: 0
						} as ICoinFlip;
						this.oForm.isSubmiting = true;
						break;
					case 'bet':
						this.betParams = {
							frontID: new Date().getTime(),
							isFast: useSettingsStore().game.coinflip.fast,
							type: 0,
							amount: Number(this.oForm.amount.beFixed(2)),
						} as ICoinFlip;
						this.coinFlipStore.betOrBack = 'bet';
						this.oForm.isSubmiting = true;
						this.roundData = {
							...this.roundData,
							odds: 0, 
							series: '0'
						}
					break;
					case 'back':
						// 这里目前出现了误判，在用户开局时误判为了提现，因此报错。偶发，排查中 
						this.betParams = {
							frontID: new Date().getTime(),
							isFast: useSettingsStore().game.coinflip.fast,
							type: 2,
						} as ICoinFlip;
						this.coinFlipStore.betOrBack = 'back';
						this.oForm.isSubmiting = false;
					break;
					default:
						
				}
			} else { // Instant
				switch(type){
					case 'head':
						this.betParams = {
							frontID: new Date().getTime(),
							isFast: useSettingsStore().game.coinflip.fast,
							type: 0,
							prediction: 1,
							amount: this.oForm.amount.beFixed(2),
						} as ICoinFlip;
						this.oForm.isSubmiting = true;
						break;
					case 'tail':
						this.betParams = {
							frontID: new Date().getTime(),
							isFast: useSettingsStore().game.coinflip.fast,
							type: 0,
							prediction: 0,
							amount: this.oForm.amount.beFixed(2),
						} as ICoinFlip;
						this.oForm.isSubmiting = true;
						break;
					default:
				}
			}
			this.betSubmit()
		}
	}
})
</script>

<style lang='scss' scoped>
.coinflip-game {
	line-height: normal;
	display: flex;
    flex-direction: column;
    overflow: hidden;
	width: 100%;

	.coinflip-game-container {
		padding: 0;
		flex: 1 1;
		min-height: 400px;
		margin-top: -2px;

		.coinflip-game-content {
			margin: 0 auto;
			max-width: 1088px;
			position: relative;
			width: 100%;

			.coinflip-game-main{
				height: auto;
				position: relative;

				.coinflip-game-section {
					&:nth-of-type(1){
						display: flex;
						justify-content: center;
						flex-direction: column;
						flex: auto;
						max-width: 650px;
						width: 100%;
						margin: 0 auto;
					}
					&:nth-of-type(2){
						margin: 20px 0 40px;
					}
					.coinflip-game-row {
						position: relative;
						&:nth-of-type(1){
							align-items: flex-end;
							display: flex;
						}
						&:nth-of-type(2){
							display: flex;
							flex-direction: column;
						}
						.button-settings {
							cursor: pointer;
							display: flex;
							justify-content: flex-end;
							margin-bottom: 12px;
							margin-top: 4px;
							width: 100%;

							&>:deep(div) {
								flex: none;

								&:not(:last-child) {
									margin-right: 5px;
								}
							}
						}

						@media (max-width: 1000px) {
							.button-settings {
								justify-content: flex-start;

								&>:deep(div) {
									flex: 1;
								}
							}
						}

						.coinflip-game-row-head {
							align-items: center;
							display: flex;
							justify-content: space-between;
							min-height: 52px;
							padding: 10px 25px;

							.coinflip-toggle {
								align-items: center;
								display: flex;

								.toggle-tool {
									margin-left: 0.5em;
								}
							}						
						}

						@media (max-width: 1100px) {
							.coinflip-game-row-head {
								padding:10px 15px
							}
						}
					}

					@media (max-width: 1000px) {
						.coinflip-game-row {
							&:nth-of-type(1) {
								align-items: flex-start;
								flex-direction: column;
							}
						}
					}
					@media (max-width: 768px) {
						@media not all and (min-resolution: 0.001dpcm) {
							@supports (-webkit-appearance:none) {
								.coinflip-game-row {
									&:nth-of-type(2) {
										min-height:-webkit-fill-available
									}
								}
							}
						}
					}
					@media (max-width: 1100px) {

						@media not all and (min-resolution: 0.001dpcm) {
							@supports (-webkit-appearance:none) {
								.coinflip-game-row {
									&:nth-of-type(2) {
										min-height:-webkit-fill-available
									}
								}
							}
						}
					}
				}
			}
		}
		@media (max-width: 768px) {
			.coinflip-game-content {
				padding-left: 4px;
				padding-right: 4px;
			}
		}
	}

	@media (max-width: 768px) {
		.coinflip-game-container {
			padding-bottom:10px;
			padding-top: 2px
		}
	}
}

</style>